import React from 'react';
import { Empty, Spin } from 'antd';
import { ChartBox } from '../../../../ResultPanel/component/ChartBox';
import ScatterChartPlotly from '../../../../../common/Chart/ScatterChartPlotly';
import styles from '../../Layout/AnalyticsLayout.module.scss';
import { IBestDataset } from '../../../../../../types/analytics';
import ErrorDisplay from '../../ErrorDisplay';

interface ScatterPlotChartProps {
  seriesX: { name: string; max: number };
  seriesY: { name: string; max: number };
  plotData: any[];
  pointName: string;
  coordinates: { lng: string; lat: string };
  downloadName: string;
  selectedDatasetInfo?: IBestDataset;
  isLoading?: boolean;
  error?: string;
  isOffline: boolean;
  xAxisInterval: number;
  yAxisInterval: number;
  emptyText?: string;
}

export const ScatterPlotChart = ({
  seriesX,
  seriesY,
  plotData,
  pointName,
  coordinates,
  downloadName,
  selectedDatasetInfo,
  isLoading = false,
  error,
  isOffline,
  xAxisInterval,
  yAxisInterval,
  emptyText = 'No data available',
}: ScatterPlotChartProps) => {
  if (error || isOffline) {
    return <ErrorDisplay error={error} isOfflineDataset={isOffline} />;
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Spin size='large' />
      </div>
    );
  }

  if (plotData.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Empty description={emptyText} />
      </div>
    );
  }

  return (
    <div className={styles.chartPointWrapper}>
      <div className={styles.analyticsPointName}>
        {pointName}
        <span className={styles.analyticsCoords}>
          ({coordinates.lng}°E; {coordinates.lat}°N)
        </span>
      </div>

      <div className={styles.chartContainer}>
        <ChartBox
          key='Scatter Plot'
          title='Scatter Plot'
          height={500}
          plot={
            <ScatterChartPlotly
              id='Analytics-ScatterPlot-Plot'
              seriesX={seriesX}
              seriesY={seriesY}
              data={plotData}
              downloadName={downloadName}
              xAxisInterval={xAxisInterval}
              yAxisInterval={yAxisInterval}
            />
          }
          dataset={selectedDatasetInfo?.label || ''}
        />
      </div>
    </div>
  );
};

export type { ScatterPlotChartProps };
